import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Trophy } from "lucide-react";
import { api, LEVELS, firstName } from "../lib/api";
import { Avatar, Empty, Loader, PageHeader, PillTabs } from "../components/common";

const PodiumSpot = ({ a, place }) => {
  if (!a) return <div />;
  const big = place === 1;
  return (
    <Link to={`/app/atletas/${a.user_id}`} data-testid={`podium-${place}`} className={`flex flex-col items-center text-center ${big ? "-mt-6" : "mt-4"}`}>
      <Avatar user={a} size={big ? 92 : 68} ring crown />
      <span className={`-mt-3 z-10 flex h-7 w-7 items-center justify-center rounded-full font-display font-black ${big ? "bg-[#E4F222] text-black" : "bg-white text-black"}`}>{place}</span>
      <div className="mt-2 text-sm font-semibold">{firstName(a.name)} {a.name.split(" ").slice(-1)[0] !== firstName(a.name) ? a.name.split(" ").slice(-1)[0] : ""}</div>
      <div className="text-xs text-[#94A3B8]">{a.total} pts</div>
    </Link>
  );
};

export default function Ranking() {
  const [level, setLevel] = useState("");
  const [rows, setRows] = useState(null);
  const [seasons, setSeasons] = useState([]);
  const [season, setSeason] = useState(null);
  useEffect(() => {
    api.get("/seasons").then((r) => { setSeasons(r.data); setSeason((r.data.find((s) => s.active) || r.data[0] || {}).id || ""); });
  }, []);
  useEffect(() => {
    if (season === null) return;
    setRows(null);
    api.get("/ranking", { params: { level, season_id: season } }).then((r) => setRows(r.data));
  }, [level, season]);
  return (
    <div>
      <PageHeader eyebrow="Temporada" title="Ranking" subtitle="Pontuação acumulada nas etapas do circuito."
        action={<select data-testid="ranking-season-select" className="inp w-auto" value={season || ""} onChange={(e) => setSeason(e.target.value)}>
          {seasons.map((s) => <option key={s.id} value={s.id}>{s.name}{s.active ? " (atual)" : ""}</option>)}
          <option value="">Todas as temporadas</option>
        </select>} />
      <PillTabs testid="ranking-level" tabs={[{ value: "", label: "Geral" }, ...LEVELS]} value={level} onChange={setLevel} />
      <div className="mt-6">
        {!rows ? <Loader /> : rows.length === 0 ? <Empty icon={Trophy} title="Sem pontuação" text="Nenhum ponto lançado neste nível ainda." /> : (
          <>
            <div className="card-x mb-4 grid grid-cols-3 items-start px-3 pb-6 pt-12" data-testid="ranking-podium">
              <PodiumSpot a={rows[1]} place={2} /><PodiumSpot a={rows[0]} place={1} /><PodiumSpot a={rows[2]} place={3} />
            </div>
            <div className="card-x divide-y divide-[#232B3E]">
              {rows.slice(3).map((a) => (
                <Link key={a.user_id} to={`/app/atletas/${a.user_id}`} data-testid={`ranking-row-${a.user_id}`} className="flex items-center gap-3 px-4 py-3 hover:bg-[#1A202E]">
                  <span className="w-6 font-display text-lg font-bold text-[#94A3B8]">{a.position}</span>
                  <Avatar user={a} size={36} />
                  <div className="min-w-0 flex-1"><div className="truncate text-sm font-semibold">{a.name}</div><div className="text-[11px] text-[#64748B]">{a.level} · {a.titles} título(s)</div></div>
                  <span className="font-display text-lg font-bold">{a.total} <span className="text-xs text-[#64748B]">pts</span></span>
                </Link>
              ))}
            </div>
          </>
        )}
      </div>
    </div>
  );
}
